module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    class: ["partition-nav", ("partition-nav--" + _vm.theme)],
    on: {
      "click": function($event) {
        _vm.ga()
      }
    }
  }, [_c('tr', [_c('td', {
    staticClass: "partition-nav__row"
  }, [_c('div', {
    class: _vm.setClass(1, 'top-left')
  }, [_vm._v("1")])]), _vm._v(" "), _c('td', {
    staticClass: "partition-nav__row"
  }, [_c('div', {
    class: _vm.setClass(2, 'top-right')
  }, [_vm._v("2")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "partition-nav__row"
  }, [_c('div', {
    class: _vm.setClass(3, 'bottom-left')
  }, [_vm._v("3")])]), _vm._v(" "), _c('td', {
    staticClass: "partition-nav__row"
  }, [_c('div', {
    class: _vm.setClass(4, 'bottom-right')
  }, [_vm._v("4")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-621c5798"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PartitionNav.vue
// module id = 118
// module chunks = 1